/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import styled from "styled-components";
import { SVGIcon, Text } from "@nordcloud/gnui";
import { FlexContainer } from "~/components";
import { flashing } from "~/components/Styled/animation";
import { EvaluationStatus } from "~/models";

const FlashingWrap = styled.div`
  opacity: 0.5;
  animation: ${flashing} 1s infinite;
`;

type StatusWrapIcon = {
  icon: "success" | "countdown" | "statusError";
  color: "success" | "warning" | "danger";
  status: string;
};

function StatusWrap({ icon, color, status }: StatusWrapIcon) {
  return (
    <FlexContainer>
      <SVGIcon name={icon} color={color} />
      <Text weight="regular" color={color} ml="0.5rem" tag="div">
        {status}
      </Text>
    </FlexContainer>
  );
}

export function displayAREvaluationStatus(type: string) {
  switch (type) {
    case EvaluationStatus.SUCCEEDED:
      return <StatusWrap icon="success" color="success" status="Succeeded" />;
    case EvaluationStatus.IN_PROGRESS:
      return (
        <FlashingWrap>
          <StatusWrap icon="countdown" color="warning" status="In Progress" />
        </FlashingWrap>
      );
    case EvaluationStatus.WAITING:
      return (
        <FlashingWrap>
          <StatusWrap icon="countdown" color="warning" status="Waiting" />
        </FlashingWrap>
      );
    case EvaluationStatus.FAILED:
      return <StatusWrap icon="statusError" color="danger" status="Failed" />;
    default:
      return (
        <Text weight="regular" tag="div">
          -
        </Text>
      );
  }
}
